<template>
  <div class="reset__password">
    <form v-if="!sent" @submit.prevent="submit">
      <h2 class="big__title__auth">
        Restaurar<br />
        contraseña
      </h2>
      <div class="input-group w-full">
        <input
          v-model="email"
          v-validate="'required|email'"
          type="email"
          nmae="email"
          placeholder="Email"
          @focusout="changeStateInput($event)"
        />
      </div>
      <div class="input-group w-full">
        <span
          v-if="errors.has('email')"
          class="pl-1 text-light-red mt-2 font-neue text-sm"
          >{{ errors.first("email") }}</span
        >
      </div>
      <div class="w-full flex flex-wrap justify-start">
        <button class="send__button__recover">
          <span :class="{ spinner: loading == true }">ENVIAR</span>
        </button>
      </div>
    </form>
    <div v-else class="relative py-3 px-6 rounded-lg flex flex-wrap">
      <h2 class="big__title__auth">
        <span>Solicitud</span><br />
        enviada
      </h2>
      <p class="text-white comment__recover">
        En los siguientes minutos, usted recibirá un correo con las
        instrucciones para la restauración de su contraseña.
      </p>
      <router-link
        :to="{ name: 'auth' }"
        class="send__button__recover no-underline uppercase"
        title="Ir a la página principal"
      >
        <span>regresar</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import ButtonRed from "@/components/ui/ButtonRed";
import api from "@/api";
export default {
  name: "ResetPassword",
  components: {
    ButtonRed,
  },
  data() {
    return {
      loading: false,
      email: "",
      sent: false,
    };
  },
  methods: {
    changeStateInput(e) {
      if (e.target.value.length > 0) {
        e.target.classList.add("has-value");
      } else {
        e.target.classList.remove("has-value");
      }
    },
    submit() {
      if (this.loading) return;
      this.loading = true;
      api.passwordReset({ email: this.email }, (err, res) => {
        this.loading = false;
        if (err) {
          return this.$swal({ title: "Ocurrio un error", type: "error" });
        }
        this.email = "";
        this.sent = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pin-t-r {
  bottom: 88%;
  left: 94%;
}
.recover__password__title {
  font-size: 55px;
  color: #fff;
  text-align: center;
  margin-bottom: 2rem;
  font-weight: 400;
  text-align: left;
  line-height: 1;
}
.input-group {
  margin: 50px 0;
}
.comment__recover {
  font-size: 22px;
  color: #fff;
  margin-bottom: 2rem;
  font-weight: 400;
  text-align: left;
  line-height: 1;
}
.form-control {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 25px;
  border: none;
  border-bottom: 1px solid lighten(black, 85%);
  background-color: transparent;
  color: var(--main-blue);

  & + label {
    position: absolute;
    top: 10px;
    left: 3px;
    font-weight: bold;
    color: lighten(black, 60%);
    transition: all 0.2s ease-out;
    color: var(--main-blue);
  }

  &:focus {
    outline: none;
    border-width: 2px;
    border-color: var(--main-blue);
    transition: all 0.2s ease-out;
  }

  &:focus + label,
  &.has-value + label {
    top: -12px;
    color: var(--main-blue);
    font-size: 10px;
    font-weight: 300;
  }
}
.big__title__auth {
  font-size: 55px;
  color: #fff;
  margin-bottom: 2rem;
  font-weight: 400;
  text-align: left;
  line-height: 1;
  @media only screen and (max-width: 992px) {
    font-size: 40px;
  }
}
.send__button__recover {
  width: 220px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0A50E6;
  color: #73c9ff;
  font-weight: bold;
  @media (min-width: 768px) {
    height: 50px;
  }
}
.reset__password {
  display: flex;
  justify-content: center;
}

input {
  border-bottom: 2px solid white;
  box-sizing: border-box;
  background-color: #73c9ff;
  font-size: 22px;
  width: 100%;
  height: 60px;
  color: white;
  padding-left: 5px;
  &:focus {
    outline: none;
    border-width: 2px;
    border-color: #0A50E6;
    transition: all 0.2s ease-out;
  }
}
</style>
